export default {
	emits: ['clickBarraChart'],
	props: {
		meses_clientes_sem_reuniao: {
			type: Array,
			required: false,
			default: () => [],
		},
		cor: {
			type: String,
			required: false,
			default: '#18b25d', // Verde como padrão
		},
	},
	data() {
		return {
			chart: null,
			customTooltip: {
				show: false,
				x: 0,
				y: 0,
				content: '',
			},
		}
	},
	computed: {
		dadosProcessados() {
			if (
				!this.meses_clientes_sem_reuniao ||
				this.meses_clientes_sem_reuniao.length === 0
			) {
				return {
					data: [],
					categories: [],
					fundacoes: [],
				}
			}

			// Ordenar decrescente por meses_sem_reuniao
			const fundacoesOrdenadas = [...this.meses_clientes_sem_reuniao].sort(
				(a, b) => b.meses_sem_reuniao - a.meses_sem_reuniao
			)

			return {
				data: fundacoesOrdenadas.map((f) => f.meses_sem_reuniao),
				categories: fundacoesOrdenadas.map((f) => f.nome_fundacao),
				fundacoes: fundacoesOrdenadas,
			}
		},
		chartOptions() {
			const alturaPorBarra = 40 // px
			const alturaGrafico = Math.max(
				this.dadosProcessados.categories.length * alturaPorBarra,
				300
			)

			return {
				series: [
					{
						name: 'Meses desde último atendimento',
						data: this.dadosProcessados.data,
					},
				],
				chart: {
					type: 'bar',
					height: alturaGrafico,
					toolbar: { show: false },
				},
				colors: [this.cor],
				plotOptions: {
					bar: {
						borderRadius: 4,
						borderRadiusApplication: 'end',
						horizontal: true,
						dataLabels: {
							position: 'top',
						},
					},
				},
				dataLabels: {
					enabled: true,
					formatter: (val) => `${val} meses`,
					offsetX: 40,
					style: {
						fontSize: '13px',
						colors: ['#304758'],
					},
				},
				xaxis: {
					categories: this.dadosProcessados.categories,
					title: {
						text: 'Meses sem atendimento',
					},
					labels: {
						style: { fontSize: '13px' },
					},
				},
				yaxis: {
					title: {
						text: 'Fundações',
					},
					labels: {
						style: { fontSize: '13px' },
					},
				},
				tooltip: {
					enabled: false,
				},
			}
		},
	},
	methods: {
		renderChart() {
			if (this.chart) {
				this.chart.destroy()
			}
			this.chart = new ApexCharts(
				this.$refs.chartPeriodoAtendimentoContainer,
				this.chartOptions
			)
			this.chart.render()

			this.chart.addEventListener(
				'dataPointSelection',
				(event, chartContext, config) => {
					const fundacao =
						this.dadosProcessados.fundacoes[config.dataPointIndex]
					this.$emit('clickBarraChart', {
						index: config.dataPointIndex,
						fundacao: fundacao,
						meses_sem_reuniao: fundacao.meses_sem_reuniao,
					})
				}
			)

			this.chart.addEventListener(
				'dataPointMouseEnter',
				(event, chartContext, config) => {
					const fundacao =
						this.dadosProcessados.fundacoes[config.dataPointIndex]
					if (!fundacao) return

					// Pega posição do mouse
					const mouseX = event.clientX
					const mouseY = event.clientY

					// Monta o conteúdo do tooltip
					const politicaNomes = {
						0: 'N/A',
						1: 'SAI',
						2: 'SAI/Cliente',
						3: 'Consultor/Gestor',
					}

					const fundosList = Array.isArray(fundacao.fundos_fundacao) && fundacao.fundos_fundacao.length
						? `<ul style="margin: 8px 0 0 0; padding-left: 18px;">
								${fundacao?.fundos_fundacao.map(fundo => `<li style="list-style-type: disc;">${fundo}</li>`).join('')}
							</ul>`
						: '<span style="color: #888;">Nenhum fundo</span>'

					const reunioesPendentesList = Array.isArray(fundacao.reunioes_pendentes) && fundacao.reunioes_pendentes.length
						? `<ul style="margin: 8px 0 0 0; padding-left: 18px;">
								${fundacao.reunioes_pendentes.map(reuniao => `<li style="list-style-type: disc;">${reuniao}</li>`).join('')}
							</ul>`
						: '<span style="color: #888;">Nenhuma reunião pendente</span>'

					const content = `
						<div style="padding: 12px; background: white; border: 1px solid #e3e3e3; border-radius: 4px; font-family: Arial, sans-serif; height: max-content;">
							<div><strong>${fundacao.nome_fundacao}</strong></div>
							<div>Meses sem atendimento: <strong>${fundacao.meses_sem_reuniao}</strong></div>
							<div>Política: <strong>${politicaNomes[fundacao.politica] || 'N/A'}</strong></div>
							<div style="margin-top: 6px;"><strong>Fundos:</strong></div>
							${fundosList}
							<div style="margin-top: 6px;"><strong>Reuniões Pendentes:</strong></div>
							${reunioesPendentesList}
						</div>
					`

					// Atualiza dados do tooltip customizado
					this.customTooltip = {
						show: true,
						x: mouseX + 10, // ajuste de deslocamento
						y: mouseY + 10,
						content,
					}
				}
			)

			// Evento de sair do hover
			this.chart.addEventListener('dataPointMouseLeave', () => {
				this.customTooltip.show = false
			})
		},
	},
	watch: {
		meses_clientes_sem_reuniao: {
			handler() {
				this.renderChart()
			},
			deep: true,
		},
	},
	mounted() {
		this.renderChart()
	},
	beforeUnmount() {
		if (this.chart) this.chart.destroy()
	},
	template: `
        <div ref="chartPeriodoAtendimentoContainer"></div>
		 <div
			v-if="customTooltip.show"
			v-html="customTooltip.content"
			:style="{
			position: 'fixed',
			left: customTooltip.x + 'px',
			top: customTooltip.y + 'px',
			zIndex: 99999999999999999999,
			pointerEvents: 'none'
			}"
		></div>
    `,
}
